import ReactDOM from "react-dom/client"
import React from "react"
import App from "./components/App"
import "./css/app.scss"

const rootElement = document.getElementById('ama-order-form')

export let ajaxUrl = null
export let formUrl = null

if (rootElement) {
    ajaxUrl = rootElement.getAttribute('data-ajaxurl')
    formUrl = rootElement.getAttribute('data-formurl')
    const root = ReactDOM.createRoot(rootElement)

    root.render(
        <App/>
    )
}
